/* ==========================================================================
   EI Footer JS — Tracking GA4 + Cookie preferences
   Events via dataLayer.push() pour GTM-TXDN6WNN
   ========================================================================== */

(function() {
  'use strict';

  /* --- Helpers --- */
  function pushEvent(event, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, params));
  }

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function() {

    /* ================================================================
       1. Footer link clicks (ZONE 2)
       ================================================================ */
    var footerLinks = document.querySelectorAll('.ei-footer-zone2 .ei-footer-column a');
    for (var i = 0; i < footerLinks.length; i++) {
      footerLinks[i].addEventListener('click', function() {
        var col = this.closest('.ei-footer-column');
        pushEvent('footer_link_click', {
          link_text: this.textContent.trim(),
          link_url: this.getAttribute('href'),
          footer_section: col ? col.getAttribute('data-section') : 'unknown'
        });
      });
    }

    /* ================================================================
       2. Newsletter submit
       ================================================================ */
    var nlForm = document.querySelector('.ei-footer-newsletter-form');
    if (nlForm) {
      nlForm.addEventListener('submit', function() {
        pushEvent('footer_newsletter_submit', { source: 'footer' });
      });
    }

    /* ================================================================
       3. Social clicks
       ================================================================ */
    var socialLinks = document.querySelectorAll('.ei-footer-social a');
    for (var j = 0; j < socialLinks.length; j++) {
      socialLinks[j].addEventListener('click', function() {
        pushEvent('footer_social_click', {
          network: this.getAttribute('data-network') || 'unknown',
          source: 'footer'
        });
      });
    }

    /* ================================================================
       4. Phone click
       ================================================================ */
    var phoneLink = document.querySelector('.ei-footer-phone');
    if (phoneLink) {
      phoneLink.addEventListener('click', function() {
        pushEvent('footer_phone_click', { source: 'footer' });
      });
    }

    /* ================================================================
       5. Trustpilot click
       ================================================================ */
    var tpBadge = document.querySelector('.ei-trustpilot-badge');
    if (tpBadge) {
      tpBadge.addEventListener('click', function() {
        pushEvent('footer_trustpilot_click', { source: 'footer' });
      });
    }

    /* ================================================================
       6. Garanties view (Intersection Observer)
       ================================================================ */
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        for (var k = 0; k < entries.length; k++) {
          if (entries[k].isIntersecting) {
            pushEvent('footer_garantie_view', {
              garantie: entries[k].target.getAttribute('data-garantie') || 'unknown'
            });
            observer.unobserve(entries[k].target);
          }
        }
      }, { threshold: 0.5 });

      var pills = document.querySelectorAll('.ei-footer-garantie-pill');
      for (var m = 0; m < pills.length; m++) {
        observer.observe(pills[m]);
      }
    }

    /* ================================================================
       7. Cookie preferences button
       ================================================================ */
    var cookieBtn = document.querySelector('.ei-footer-cookies-btn');
    if (cookieBtn) {
      cookieBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var reopenBtn = document.getElementById('ei-cookie-reopen');
        if (reopenBtn) { reopenBtn.click(); }
      });
    }

  });
})();